import React, { useEffect, useState, useRef } from "react";
import $ from "jquery";
import { SET_GAME_BONUS_RESULT_POST } from "../../api/ApiConst";
import { callPostApi } from "../../api/ApiCaller";
import { getFormattedAmountWithDenomination } from "../../utils/TextUtils";

let interactionDisabled = false;
const Bonus01BombaStrawberry = ({ keyboardInput, gameSessionRecordId, onBonusRoundCompleted, walletBalance, denomination }) => {
    const SoundBgRef = useRef(null);
    const [bonusWinnings, setBonusWinnings] = useState(0);
    const [bonusValue, setBonusValue] = useState(0);
    const [premioValue, setPremioValue] = useState(0);
    const [isAnimatingPremioValue, setISAnimatingPremioValue] = useState(false);
    const [isAnimatingBonusValue, setIsAnimatingBonusValue] = useState(false);
    const [gameTotalWinn, setGameTotalWinn] = useState(0);
    const [selectedNo, setSelectedNo] = useState(0)
    const [scrathNo, setScratchNumber] = useState(false);
    // const [denomination, setDenomination] = useState(0.01);

    const defaultRecords = new Array(12).fill({
        disabled: false,
        scratched: true,
        stopAnimation: false,
        bonusAmount: 0,
    });

    const [records, setRecords] = useState(defaultRecords);
    const [refreshKey, setRefreshKey] = useState(Date.now());

    const rows = [
        [0, 1, 2],
        [3, 4, 5],
        [6, 7, 8],
        [9, 10, 11],
    ];

    useEffect(() => {
        setRefreshKey(Date.now());
    }, []);

    const playSoundById = (soundTagId) => {
        let sound = $("#" + soundTagId)[0];
        if (sound) {
            sound.currentTime = 0;
            sound.play();
        }
    };
    const pauseSoundById = (soundTagId) => {
        let sound = $("#" + soundTagId)[0];
        if (sound) {
            sound.pause();
            sound.currentTime = 0;
        }
    };

    const animatePremioValue = (newPremioValue) => {
        if (isAnimatingPremioValue) return;
        setISAnimatingPremioValue(true);
        let currentValue = premioValue;
        const steps = newPremioValue > 0 ? 50 : 100;
        let stepSize = (newPremioValue - currentValue) / steps;
        const animationSpeed = newPremioValue > 0 ? 3 : 12;

        let intervalId = setInterval(() => {
            currentValue += stepSize;
            setPremioValue(Math.round(currentValue));
            if (Math.abs(currentValue - newPremioValue) < Math.abs(stepSize)) {
                clearInterval(intervalId);
                setPremioValue(newPremioValue);
                setISAnimatingPremioValue(false);
            }
        }, animationSpeed);
        interactionDisabled = false;
    };
    const animateBonusValue = (newBonusValue, totalWinning) => {
        if (isAnimatingBonusValue) return;
        setIsAnimatingBonusValue(true);

        let currentValue = bonusValue;
        let steps = 100;
        let stepSize = (newBonusValue - currentValue) / steps;
        let animationSpeed = 12;

        const intervalId = setInterval(() => {
            currentValue += stepSize;
            let bonusRoundValue = Math.round(currentValue);
            setBonusValue(bonusRoundValue);
            if (Math.abs(currentValue - newBonusValue) < Math.abs(stepSize) || currentValue === newBonusValue || (stepSize === 0 && newBonusValue === 0)) {
                clearInterval(intervalId);
                setBonusValue(newBonusValue);
                setIsAnimatingBonusValue(false);
                setTimeout(() => {
                    onBonusRoundCompleted(totalWinning);
                }, 2000);
            }
        }, animationSpeed);
    };

    const loadStaticAudio = () => {
        return (
            <>
                <div style={{ display: "none" }}>
                    {/* Load Audio as Well */}
                    <audio controls="" id="strawberryBg" className="audioFile">
                        <source src="assets/strawberryBg.mp3" type="audio/mpeg" />
                    </audio>
                    <audio controls="" id="strawberrySelect" className="audioFile">
                        <source src="assets/bomba-strawberry1.ogg" type="audio/ogg" />
                    </audio>
                    <audio controls="" id="strawberryStop" className="audioFile">
                        <source src="assets/bomba-strawberry2.ogg" type="audio/ogg" />
                    </audio>
                </div>
            </>
        );
    };

    const drawHeader = () => {
        return (
            <>
                <div className="header">
                    <div className="row align-content-center">
                        <div className="col-4">
                            <div className="d-flex align-content-center gap-2 ">
                                <div className="btn-heading">CRÉDITO</div>
                                <div className="header-custom-btn"> {getFormattedAmountWithDenomination(walletBalance, denomination)}</div>
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="d-flex align-content-center gap-2 justify-content-end ">
                                <div className="btn-heading">Premio</div>
                                <div className="header-custom-btn">{premioValue}</div>
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="d-flex align-content-center gap-2 justify-content-center ">
                                <div className="btn-heading">Bonus</div>
                                <div className="header-custom-btn">{bonusValue}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    };

    // column-major order me agla index (handleNumberChange jaisa hi: 0→3→6→9→1→4→7→10→2→5→8→11→0)
    const stepIndex = (n) => (n === 11 ? 0 : n + 3 > 11 ? n - 8 : n + 3);

    // diye gaye index ke baad pehla aisa box jo abhi disabled (open) nahi hua
    const getNextSelectableNo = (recs, fromIndex) => {
        let i = fromIndex;
        for (let c = 0; c < 12; c++) {
            i = stepIndex(i);
            if (!recs[i]?.disabled) return i;
        }
        return -1; // koi box bacha nahi
    };

    const handleNumberChange = () => {
        setSelectedNo((prevSelectedNo) => {
            let newNum = prevSelectedNo + 3 > 11 ? prevSelectedNo - 8 : prevSelectedNo + 3;
            if (prevSelectedNo === 11) {
                newNum = 0;
            }
            if (!records[newNum]?.disabled) {
                return newNum
            }
            else {
                for (let i = newNum; i < 12;) {
                    if (!records[i]?.disabled) {
                        return i;
                    }
                    if (i == 11) {
                        break;
                    }
                    if (i + 3 > 11) {
                        i = i - 8;
                    }
                    else {
                        i = i + 3;
                    }
                }
                for (let i = 0; i < newNum;) {
                    if (!records[i]?.disabled) {
                        return i
                    };
                    if (i == 11) break;
                    if (i + 3 > 11) {
                        i = i - 8;
                    }
                    else {
                        i = i + 3;
                    }
                }
                return -1;
            }


        })


    }


    useEffect(() => {
        if (scrathNo) {
            handleBoxClick(records[selectedNo], selectedNo)
            setScratchNumber(false)
        }
    }, [scrathNo, selectedNo])

    useEffect(() => {
        const handleKeyPress = (event) => {
            const key = event.key.toLowerCase();
            if (["t", "y", "j", "h", "m", "n", "v"].includes(key)) {

                handleNumberChange()
            }
            else if (key === "b") {
                setScratchNumber(true)
            }
        };

        if (keyboardInput) {
            window.addEventListener("keydown", handleKeyPress);
            return () => {
                window.removeEventListener("keydown", handleKeyPress);
            };
        }


    }, [keyboardInput, records]);

    useEffect(() => {
        SoundBgRef.current = $("#strawberryBg")[0];

        if (SoundBgRef.current) {
            SoundBgRef.current.loop = true;
            if (SoundBgRef.current.paused) {
                SoundBgRef.current.play().catch((err) => {
                    console.error("Audio play failed:", err);
                });
            }
        }
    }, [])

    const handleBoxClick = (record, index) => {
        if (interactionDisabled) return;
        if (record?.disabled) return;
        interactionDisabled = true;
        setSelectedNo(index); // highlight the box being opened (mouse click bhi cursor move kare)
        let stopSound = SoundBgRef.current

        if (stopSound.paused) {
            stopSound.play().catch((err) => {
                console.error("Audio play failed:", err);
            });
        }
        // playSoundById("strawberryBg");

        let payload = {
            bonusType: "Bonus01Strawberry",
            recordId: gameSessionRecordId,
            tileNumber: index,
        };

        callPostApi(SET_GAME_BONUS_RESULT_POST, payload, {}, (response) => {
            let res = response?.responsePacket;
            if (response?.errorCode === 0) {
                let bonusNumber = res?.bonusDetails?.bonus;
                let totalGameWinning = res?.totalWinnings
                setBonusWinnings(bonusWinnings + bonusNumber);
                setGameTotalWinn(totalGameWinning);
                if (bonusNumber > 0) {
                    // pauseSoundById("strawberryBg");
                    // const stopSound = $("#strawberryBg")[0];
                    if (!stopSound.paused) {
                        stopSound.pause();
                    }

                    let _records = [...records];
                    let updatedRecord = {
                        disabled: true,
                        scratched: false,
                        stopAnimation: false,
                        bonusAmount: bonusNumber,
                    };
                    playSoundById("strawberrySelect");
                    setTimeout(() => {
                        pauseSoundById("strawberrySelect");
                        if (stopSound.paused) {
                            stopSound.play().catch((err) => {
                                console.error("Audio play failed:", err);
                            });
                        }
                    }, 700);

                    _records[index] = updatedRecord;
                    setRecords(_records);

                    setTimeout(() => {
                        setPremioValue((prevPremioValue) => {
                            let updatePremio = prevPremioValue + bonusNumber;
                            animatePremioValue(updatePremio);
                            return updatePremio;
                        });
                    }, 700);

                    setTimeout(() => {
                        const valueDiv = document.getElementById(`value-div-${index}`);
                        if (valueDiv) {
                            if (valueDiv.classList.contains("d-none")) {
                                valueDiv.classList.remove("d-none");
                            }
                        }
                        // box open hone ke baad highlight ko agle available box par le jao
                        setSelectedNo(getNextSelectableNo(_records, index));
                    }, 750);
                } else {
                    // pauseSoundById("strawberryBg");
                    if (!stopSound.paused) {
                        stopSound.pause();
                        stopSound.currentTime = 0;
                        stopSound.loop = false;
                    }
                    animatePremioValue(0);
                    animateBonusValue(bonusWinnings, totalGameWinning);
                    let _records = [...records];
                    let updatedRecord = {
                        disabled: true,
                        scratched: false,
                        stopAnimation: true,
                        bonusAmount: 0,
                    };
                    playSoundById("strawberryStop");

                    _records[index] = updatedRecord;
                    let _updatedRecords = _records.map((item) => ({
                        ...item,
                        disabled: true,
                    }));
                    setRecords(_updatedRecords);
                }
            } else {
                console.error("API Call Failed:", response?.errorMessage || "Unknown error");
            }
            setTimeout(() => {
                interactionDisabled = false;
            }, 1000);
        });
    };

    const drawBody = () => {
        return (
            <>
                <div className="strawberry-bonus-block position-relative">
                    <h4>Escolha as frutas boas e aumente seu bonus!</h4>
                    <div className="strawberry-bonus-block-row h-100">
                        <div className="strawberry-board-row ">
                            {rows.map((item, i) => (
                                <div key={"row" + i} className="strawberry-boardContent ">
                                    {item.map((value) => (
                                        <div
                                            key={"col" + value}
                                            className={`strawberry-boardContentBox ${selectedNo === value ? "selectedNo" : ""}`}
                                            onClick={() => {
                                                if (!interactionDisabled) {
                                                    handleBoxClick(records[value], value);
                                                }
                                            }}
                                        >
                                            {!records[value].scratched ? (
                                                <div className=" position-absolute top-0 end-0 bottom-0 start-0 ">
                                                    {!records[value].stopAnimation ? (
                                                        <>
                                                            <img className="dice-image" src={`assets/img/strawberries/anim-abrindo.gif?v=${gameSessionRecordId + "-" + value}`} />
                                                            {/* <div className="gif-value">{records[value].bonusAmount}</div> */}
                                                        </>
                                                    ) : (
                                                        <div className="dice-image h-100 w-100 position-absolute text-white">
                                                            <img className="dice-image fim-do" src="assets/img/strawberries/fim-do-bonus.gif?key=${refreshKey}" />
                                                        </div>
                                                    )}
                                                </div>
                                            ) : (
                                                <img className="dice-image" src="assets/img/strawberries/anim-girando.gif?key=${refreshKey}" />
                                            )}
                                            <div id={`value-div-${value}`} className="gif-value d-none">
                                                {records[value].bonusAmount}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </>
        );
    };

    return (
        <>
            <div className="h-100 w-100 position-relative bomba-strawberry">
                <img className="h-100 w-100" src="assets/img/strawberries/bg.png" alt="" />
                <div className="contentPosition">
                    {drawHeader()}
                    {drawBody()}
                </div>
            </div>
            {loadStaticAudio()}
        </>
    );
};

export default Bonus01BombaStrawberry;
